module.exports = __webpack_public_path__ + "img/logo2.8ecbab86.svg";